export const ENV = {
  REACT_APP_HOME_MINIAPP_HEADER_TITLE: process.env.REACT_APP_HOME_MINIAPP_HEADER_TITLE || 'Giao thông số',
  REACT_APP_RUNTIME_MODE: process.env.REACT_APP_RUNTIME_MODE || 'developer',
  REACT_APP_MINIAPP_VNPAY: process.env.REACT_APP_MINIAPP_VNPAY || '0',
  REACT_APP_DEFAULT_VISIBLE_TOP_BANNER: (process.env.REACT_APP_DEFAULT_VISIBLE_TOP_BANNER || 'false') === 'true',
  REACT_APP_DEFAULT_VISIBLE_BOTTOM_BANNER: (process.env.REACT_APP_DEFAULT_VISIBLE_BOTTOM_BANNER || 'false') === 'true',
}
